import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Sparkles, ArrowRight, User } from "lucide-react";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gallery").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-narrow py-12 md:py-16" data-testid="gallery-page">
      <div className="text-center mb-12">
        <div className="label-eyebrow mb-3">Shipped with Durga</div>
        <h1 className="font-heading text-4xl md:text-6xl font-semibold leading-tight">
          The <span className="italic text-marigold">App Atlas</span>.
        </h1>
        <p className="text-ink2 mt-4 max-w-2xl mx-auto">
          Real blueprints, generated in the Studio and shared by the community. Open any one in the Studio to remix it.
        </p>
      </div>

      {loading ? (
        <div className="text-center text-ink2 py-20">Loading the atlas…</div>
      ) : items.length === 0 ? (
        <div className="card-soft p-12 text-center max-w-xl mx-auto" data-testid="gallery-empty">
          <Sparkles className="w-8 h-8 text-marigold mx-auto mb-3" />
          <h2 className="font-heading text-2xl font-semibold mb-2">An empty atlas — for now.</h2>
          <p className="text-ink2 mb-6">
            Be the first to share a blueprint. Generate one in the Studio, then flip it public from your dashboard.
          </p>
          <Link to="/studio" className="btn-primary" data-testid="gallery-empty-cta">
            Generate a blueprint <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="gallery-grid">
          {items.map(bp => (
            <Link key={bp.id} to={`/gallery/${bp.id}`} className="card-soft p-6 group hover:-translate-y-1 transition-all" data-testid={`gallery-card-${bp.id}`}>
              <div className="label-eyebrow mb-3">App blueprint</div>
              <h3 className="font-heading text-2xl font-semibold mb-2 leading-snug">{bp.title}</h3>
              <p className="text-sm text-ink2 line-clamp-3 mb-5">{bp.concept}</p>
              <div className="flex flex-wrap gap-1.5 mb-5">
                {(bp.components || []).slice(0, 3).map((c, i) => (
                  <span key={i} className="px-2.5 py-0.5 rounded-full bg-paper text-ink text-[11px] font-medium border border-border">{c}</span>
                ))}
                {bp.components?.length > 3 && (
                  <span className="px-2.5 py-0.5 text-[11px] text-ink2">+{bp.components.length - 3}</span>
                )}
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="inline-flex items-center gap-1.5 text-ink2">
                  <User className="w-3.5 h-3.5" /> {bp.author_name || "Anonymous"}
                </span>
                <span className="inline-flex items-center text-marigold font-medium group-hover:gap-1.5 gap-1 transition-all">
                  Open <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
